import axios from 'axios';
import apiCryptography from '../utils/apiCryptography';

export const POST = async (url, data) => {
  const response = await axios
  //remove process.env.REACT_APP_SUB_DOMAIN}/ 
    .post(
      `${process.env.REACT_APP_SUB_DOMAIN}/api/auth/Authenticate`,
      {
        ApiSystem: 'DOCUPLOAD',
      },
      {
        headers: {
          'X-CSRF-TOKEN': `${getCookie('CSRF-TOKEN')}`,
        },
      }
    )
    .then(async (token) => {      
      return await axios
        .post(`${process.env.REACT_APP_SUB_DOMAIN}/` + url, data, {
          headers: {
            Authorization: `Bearer ${token?.data}`,
            'X-CSRF-TOKEN': `${getCookie('CSRF-TOKEN')}`,
          },
        })
        .then((res) => {
          return res;
        })
          .catch(function (error) {

          return error.response;
        });
        
    })
      .catch(function (error) {

      return error.response;
    });
  return response;
};

export const GET = async (url) => {
  const response = await axios
    .get(`${process.env.REACT_APP_SUB_DOMAIN}/` + url, {
      headers: {
        'X-CSRF-TOKEN': `${getCookie('CSRF-TOKEN')}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch(function (error) {
      if (error.response) {
        return {
          data: {
            status: 500,
            error: 'System Error. Please try again later.',
          },
        };
      }
    });
  return response;
};

export const GETIP = async () => {
  const response = await axios
    .post(
      `${process.env.REACT_APP_SUB_DOMAIN}/api/auth/Authenticate`,
      {
        ApiSystem: 'DOCUPLOAD',
      },
      {
        headers: {
          'X-CSRF-TOKEN': `${getCookie('CSRF-TOKEN')}`,
        },
      }
    )
    .then(async (token) => {          
      var localIP = JSON.stringify(token.headers['x-codepedia-custom-header-response']).replace(/"/g, "");
      var decIP = apiCryptography.decrypt(localIP);
    //  window.localStorage.setItem('LOCALIP', '10.11.51.46' );   
      window.localStorage.setItem('LOCALIP', decIP);
      return decIP; 
    })
      .catch(function (error) {
      return error.response;
    });
  return response;
};

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
